export enum FormInputPosition {
    nextToLabel = 'nextToLabel',
    belowLabel = 'belowLabel',
    singleLine = 'singleLine',
}
